import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col md:flex-row md:mr-auto md:ml-0 mx-auto" }
const _hoisted_3 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 md:pr-8 mx-auto" }
const _hoisted_4 = { class: "py-6" }
const _hoisted_5 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_6 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, watch, shallowRef } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import DateSelector from "@/components/tools/DateTimeSelector.vue";
import WithdrawTransactionFilterDialog from "@/components/dialogs/WithdrawTransactionFilterDialog.vue";
import ButtonElement from "@/components/tools/ButtonElement.vue";
import { formatNumber, translate, timeDiff } from "@/utils/tools";

import router from "@/router";
import ConfirmRejectDialog from "@/components/dialogs/ConfirmRejectDialog.vue";
import Toast from "@/components/tools/Toast.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawV2',
  setup(__props) {

dayjs.extend(localizedFormat);
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref(false);
const isConfirmed = ref(false);
const selectedRow = ref();
const toastConfig = ref({
  show: false,
  message: "",
  success: false,
  warning:false
});

const rejectButton = shallowRef(ButtonElement);
const clearHoldBalanceButton = shallowRef(ButtonElement);

const reject = async () => {
  const payload = {
    requestId: selectedRow.value?.id,
    requestTs: Date.now(),
    userId: selectedRow.value?.user_id,
    username: selectedRow.value?.user_name,
    phoneNumber: selectedRow.value?.user_phone,
    appId: selectedRow.value?.app_id,
    operatorId: selectedRow.value?.operator_id,
    amount: selectedRow.value?.amount,
    channel: "RTB",
    refCode: selectedRow.value?.ref_code,
    withdrawId: selectedRow.value?.withdraw_id,
    timestamp: Date.now(),
    adminId: store.state.user.id,
    adminUsername: store.state.user.username,
    rtbId: selectedRow.value?.rtb_id,
    referenceRequest: selectedRow.value,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/transaction/withdraw-reject`;
  try {
    await axios.post(url, payload);
    toastConfig.value = {
      message: "reject transaction success",
      show: true,
      success: true,
      warning:false
    };
    await fetchPageData();
  } catch (error) {
    toastConfig.value = {
      message: error as string,
      show: true,
      success: false,
      warning:false
    };

    // alert(error);
  }
  isConfirmed.value = false;
};

const confirmReject = async (data: any) => {
  isConfirmed.value = true;
  selectedRow.value = data;
};

const columns = ref([
  {
    label: translate("messages.withdrawTransaction.user"),
    field: "username",
    class: () => "hover:underline cursor-pointer",
    isFunction: true,
    function: (data: any) => {
      window.open(`/players/${data.userId ? data.userId : data.user_id}`, '_blank');
      // router.push(`/players/${data.user_id}`);
    },
    format: (data: any) =>
      data.user_phone ? data.user_phone.replace("+66", "0") : data.user_id,
  },
  {
    label: translate("messages.withdrawTransaction.status"),
    field: "status",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => (data.approve_status ? data.approve_status : "-"),
    class: (data: any) => {
      let base = "text-white rounded ";
      data.approve_status === "REJECTED"
        ? (base += " bg-red-500 ")
        : data.approve_status.includes("SUCCESS")
        ? (base += " bg-green-500")
        : (base += " bg-yellow-500");

      return base;
    },
  },
  {
    label: translate("messages.withdrawTransaction.amount"),
    field: "amount",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.amount, 100),
    class: (data: any) =>
      Number(data.amount) < 0 ? "text-red-500" : "text-green-500",
  },
  {
    label: translate("messages.withdrawTransaction.paymentGatewayId"),
    field: "rtb_id",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => {
      return data.rtb_id ? data.rtb_id : (data.ref_code? data.ref_code:"-")
    },
  },
  {
    label: translate("messages.withdrawTransaction.channel"),
    field: "channel",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => (data.channel ? data.channel : "-"),
  },
  {
    label: translate("messages.withdrawTransaction.dateRequested"),
    field: "requested_at",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.requested_at).locale("th").format("LLL"),
  },
  {
    label: translate("messages.withdrawTransaction.dateApproved"),
    field: "requested_at",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.approve_at).locale("th").format("LLL"),
  },
  {
    label: translate("messages.withdrawTransaction.approvedBy"),
    field: "admin",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => (data.approve_by ? data.approve_by : "-"),
  },
  {
    label: translate("messages.withdrawTransaction.approveMessage"),
    field: "admin",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => (data.approve_msg ? data.approve_msg : "-"),
  },
  {
    element: rejectButton,
    field: "",
    align: "center",
    isFunction: true,
    class: (data: any) =>
      timeDiff(data.requested_at) > 30 &&
      data.approve_status === "AUTO_APPROVED"
        ? "block"
        : "hidden",
    format: (data: any) => {
      return timeDiff(data.requested_at) > 30 &&
        data.approve_status === "AUTO_APPROVED"
        ? translate("messages.withdrawTransaction.reject")
        : "";
    },
    function: (data: any) =>
      timeDiff(data.requested_at) > 30 ? confirmReject(data) : null,
  },
  {
    element: clearHoldBalanceButton,
    field: "",
    align: "center",
    isFunction: true,
    class: (data: any) => {
      return data.approve_status === "PAYOUT_SUBMITED" &&
        store.state.user.permissions.includes("USER.MANUAL_CLEAR_HOLD_BALANCE")
        ? "block"
        : "hidden";
    },
    format: (data: any) =>
      translate("messages.withdrawTransaction.clearHoldBalance"),
    function: (data: any) => clearHoldBalance(data),
  },
]);

const filterModal = (data = { flag: 0, chanel: null, status: null }) => {
  advanceFilterModal.value = !advanceFilterModal.value;
  if (data.flag == 1) {
    pageConfig.value.page = 1;
    filterForm.value.approve_status = data.status;
    filterForm.value.channel = data.chanel;
    fetchPageData();
  }
};

const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  sort: [["requested_at", "DESC"]],
});

const filterForm = ref({
  user_phone: null,
  approve_status: null,
  approve_by: null,
  from: null,
  channel: null,
  to: null,
});

const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  if (attName === "Date Requested") attName = "seq_num";
  if (attName === "Date Approved") attName = "approve_at";
  if (attName === "Approved By") attName = "approve_by";
  if (attName === "Status") attName = "approve_status";
  sort[0] = [attName.toLowerCase(), mode === "DESC" ? "ASC" : "DESC"];

  fetchPageData();
};

const fetchPageData = async () => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort } = pageConfig.value;
  const { user_phone, approve_status, approve_by, from, to, channel } = filterForm.value;
  // let sort = [["created_at", "DESC"]]
  // let sort = sortBy.value.length ? sortBy.value : [["created_at", "DESC"]];
  const payload: any = {
    operatorId: store.state.selectedOperator.operatorId,
    page: page - 1,
    pageSize: rowsPerPage,
    fillter: {
      user_name: user_phone
        ? user_phone
        : undefined,
      approve_status: approve_status && approve_status !== "All" ? approve_status : undefined,
      approve_by: approve_by || undefined,
      channel: channel || undefined,
    },
    startDate: dayjs(from) || null,
    endDate: dayjs(to) || null,
    sortBy: sort,
  };
  if (!from) delete payload.startDate;
  if (!to) delete payload.endDate;

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/cms/withdraw-record-all/pagination`;
  const { result: data } = await axios
    .post(url, payload)
    .then(({ data }) => data);

  pageConfig.value.dataLength = data.length;

  if (data.length > 0) dataRows.value = data;
  else dataRows.value = [];
  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};
const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData();
};
const clearHoldBalance = async (data: any) => {
  try {
    if (confirm(`Are you sure you want to clear hold balance for this transaction?`)) {
      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/internal/rtb/internal/withdraws/reconcile`;
      const payload = {
        admin_id: store.state.user.id,
        rtb_id: data.rtb_id,
        operator_id: data.operator_id,
      };
      await axios.post(url, payload);
      alert("Clear hold balance success");
      fetchPageData();
    }
  } catch (error: any) {
    alert(error.response.data.message);
  }
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.withdrawTransaction.withdrawTransactions')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DateSelector, { onSearch: onSearch }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "md:ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (advanceFilterModal.value = true))
          }, [
            _createVNode(_component_font_awesome_icon, {
              class: "text-white mr-2",
              icon: ['far', 'filter'],
              transform: ""
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.withdrawTransaction.advanceFilter")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value,
            onSort: doSort,
            isLoaded: isLoaded.value
          }, null, 8, ["columns", "data", "isLoaded"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"])
        ])
      ])
    ]),
    _createVNode(WithdrawTransactionFilterDialog, {
      class: "z-10",
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[3] || (_cache[3] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"]),
    _createVNode(ConfirmRejectDialog, {
      show: isConfirmed.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((isConfirmed).value = $event)),
      onSubmit: reject
    }, null, 8, ["show"]),
    _createVNode(Toast, {
      show: toastConfig.value.show,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((toastConfig.value.show) = $event)),
      message: toastConfig.value.message,
      success: toastConfig.value.success
    }, null, 8, ["show", "message", "success"])
  ], 64))
}
}

})